function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3729",
  "data-name": "Grupo 3729",
  transform: "translate(-159.314 -235.276)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_911",
  "data-name": "Caminho 911",
  d: "M247.182,310.091l-32.122-54.827a111.913,111.913,0,0,0-55.747,96.843H223.1A48.667,48.667,0,0,1,247.182,310.091Z",
  transform: "translate(0 -4.867)",
  fill: "#fc9d73"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_912",
  "data-name": "Caminho 912",
  d: "M370.41,254.53l-30.876,54.946a48.674,48.674,0,0,1,24.843,42.452h62.746A111.922,111.922,0,0,0,370.41,254.53Z",
  transform: "translate(-43.881 -4.688)",
  fill: "#93d0a9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_913",
  "data-name": "Caminho 913",
  d: "M289.739,298.541a48.467,48.467,0,0,1,23.856,6.247l30.876-54.946A112.067,112.067,0,0,0,233,250.4l32.121,54.827A48.461,48.461,0,0,1,289.739,298.541Z",
  transform: "translate(-17.942)",
  fill: "#ffe8be"
}));

var _ref3 = /*#__PURE__*/React.createElement("text", {
  id: "POUCA",
  transform: "translate(10 69.777)",
  fill: "#23364a",
  fontSize: 14,
  fontFamily: "SegoeUI-Bold, Segoe UI",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  x: 3,
  y: 15
}, "POUCA"));

var _ref4 = /*#__PURE__*/React.createElement("text", {
  id: "GRANDE",
  transform: "translate(156 69.777)",
  fill: "#23364a",
  fontSize: 14,
  fontFamily: "SegoeUI-Bold, Segoe UI",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  x: 1,
  y: 15
}, "GRANDE"));

var _ref5 = /*#__PURE__*/React.createElement("text", {
  id: "M\\xC9DIA",
  transform: "translate(83 24.777)",
  fill: "#23364a",
  fontSize: 14,
  fontFamily: "SegoeUI-Bold, Segoe UI",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  x: 5,
  y: 15
}, "M\xC9DIA"));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Elipse_171",
  "data-name": "Elipse 171",
  transform: "translate(107 106.777)",
  fill: "#030522",
  stroke: "#707070",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 4.5,
  fill: "none"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_914",
  "data-name": "Caminho 914",
  d: "M7318.487,9312l47.348,28.058v-6.633Z",
  transform: "translate(-7253 -9225.224)",
  fill: "#030522"
});

var SvgIndice = function SvgIndice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_24_1",
    "data-name": "Componente 24 \\u2013 1",
    width: 223.928,
    height: 116.777,
    viewBox: "0 0 223.928 116.777",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIndice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Indice.18ef0705.svg";
export { ForwardRef as ReactComponent };